import "./Component1.css";
import { Link } from "react-router-dom";
import React, { useEffect } from "react";

const Component1 = ({ Data, Categories, onCategorySelect }) => {
  useEffect(() => {
    const carouselElement = document.querySelector(
      "#carouselExampleIndicators"
    );
    if (carouselElement) {
      const carousel = new window.bootstrap.Carousel(carouselElement);
      return () => {
        carousel.dispose();
      };
    }
  }, [Data]);

  // Don't render if no data
  if (!Data || Data.length === 0) {
    return null;
  }

  return (
    <section className=" mb-5 mt-3 mt-lg-0">
      <div className="container">
        <div className="row">
          <div className="col-3 col-xl-2 d-none d-lg-block l_nave">
            <div className="py-2 lister">
              <ul className=" p-0">
                <ul className=" p-0">
                  {Categories && Categories.length > 0 ? (
                    Categories.map((cat, index) => (
                      <li key={index} className="nav-item">
                        <Link
                          to={cat.categoryLink}
                          className="nav-link category-link"
                          onClick={(e) => {
                            e.preventDefault();
                            onCategorySelect && onCategorySelect(cat.categoryName);
                          }}
                        >
                          {cat.categoryImage && (
                            <div className="category-image-wrapper">
                              <img 
                                src={cat.categoryImage} 
                                alt={cat.categoryName}
                                className="category-thumbnail"
                              />
                            </div>
                          )}
                          <span>{cat.categoryName}</span>
                          <i className="bi bi-chevron-right float-end" />
                        </Link>
                      </li>
                    ))
                  ) : (
                    <li className="nav-item">
                      <span className="nav-link">No Categories Found</span>
                    </li>
                  )}
                </ul>
              </ul>
            </div>
          </div>
          <div className="col-12 col-lg-9 m-0 m-auto ponar pt-2 mt-0 mt-lg-4">
            <div
              id="carouselExampleIndicators"
              className="carousel slide"
              data-bs-ride="carousel"
              data-bs-interval="3000"
            >
              <ol className="carousel-indicators">
                {Data.map((item) => (
                  <li
                    data-bs-target="#carouselExampleIndicators"
                    data-bs-slide-to={item.sliderId - 1}
                    className={`${item.activeSlider} mx-1 m-0 m-auto`}
                    id="li_"
                    key={item.sliderId}
                  ></li>
                ))}
              </ol>
              <div className="carousel-inner">
                {Data.map((item) => (
                  <div
                    key={item.sliderId}
                    className={`carousel-item ${item.activeSlider}`}
                  >
                    <div className="row w-100">
                      <div className="col-12 col-lg-5 m-0 m-auto l_carousel">
                        <div className="mt-4 ms-3 mt-lg-0 mt-lg-0">
                          <div className="d-flex gap-3 mb-2">
                            <img
                              src={item.brandIcon}
                              alt=""
                              className="mb-2"
                              width="30px"
                            />
                            <h5 className="align-content-center">
                              {item.productName}
                            </h5>
                          </div>
                          <h1>{item.productTitle}</h1>
                          <div className="d-flex mt-4">
                            <Link
                              to={item.productLink}
                              className="d-flex gap-2"
                            >
                              <span className="mb-1 pb-1">Shop Now</span>
                              <i className="bi bi-arrow-right" />
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-lg-6 r_carousel mt-5 mt-lg-3  mb-4">
                        <img src={item.productImage} alt="" width="100%" />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Component1;
